import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'groupSiteConfigId', 'willCreateCategoryName', 'groupSiteConfigCategoryOrderById'];

  static values = {
    categoryId: Number,
  };

  connect() {
    console.log('load category controller.');
  }

  async enableGroupCategory() {
    this.updateGroupCategoryEnabledValue(true);
  }

  async disableGroupCategory() {
    this.updateGroupCategoryEnabledValue(false);
  }

  async updateGroupCategoryEnabledValue(value) {
    const groupSiteConfigId = this.groupSiteConfigIdTarget.value;
    const groupSiteConfigCategoryEnabled = { value };
    this.callApi(
      `/api/group-siteconfigs/${groupSiteConfigId}/value`,
      groupSiteConfigCategoryEnabled,
      'PUT',
      () => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  async create() {
    const newCategoryName = this.willCreateCategoryNameTarget.value.trim();
    if (!this.isValidCategoryName(newCategoryName)) {
      window.$sendAlert('카테고리 이름은 빈 값일 수 없습니다.');
      return;
    }

    const body = {
      name: newCategoryName,
    };

    this.callApi(
      '/api/categories',
      body,
      'POST',
      (res) => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  async edit() {
    const name = document.getElementById(`category-${this.categoryIdValue}`).value;
    if (!this.isValidCategoryName(name)) {
      window.$sendAlert('카테고리 이름은 빈 값일 수 없습니다.');
      return;
    }
    const body = {
      name,
    };
    this.callApi(
      `/api/categories/${this.categoryIdValue}`,
      body,
      'PUT',
      (res) => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  async delete() {
    this.callApi(
      `/api/categories/${this.categoryIdValue}`,
      null,
      'DELETE',
      (res) => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  async changeDefaultCategory(event) {
    const defaultCategoryId = event.target.value;
    this.callApi(
      `/api/categories/${defaultCategoryId}/default`,
      null,
      'PUT',
      (res) => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  async changeCategoryOrderBy(event) {
    const groupSiteConfigId = this.groupSiteConfigCategoryOrderByIdTarget.value;
    const groupSiteConfigCategoryOrderBy = { value: event.target.value };
    this.callApi(
      `/api/group-siteconfigs/${groupSiteConfigId}/value`,
      groupSiteConfigCategoryOrderBy,
      'PUT',
      () => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      }
    )
  }



  callApi(url, body, method, successCallback, failedCallback) {
    fetch(_spring['context_path'] + url, {
      method,
      credentials: 'include',
      headers: Object.assign({}, _csrf, { 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        if (res.ok) {
          if (Number(res.headers.get('content-length')) === 0) {
            return;
          } else {
            return res.json();
          }
        }
        return Promise.reject(res.json());
      })
      .then((res) => {
        if (successCallback !== undefined && successCallback !== null) {
          successCallback(res);
        }
      })
      .catch((error) => {
        if (failedCallback !== undefined && failedCallback !== null) {
          error.then((err) => {
            failedCallback(err);
          });
        }
      });
  }

  isValidCategoryName(categoryName) {
    if (categoryName.length === null || categoryName === undefined || categoryName.length === 0) {
      return false;
    }
    return true;
  }
}
